import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const DashboardinfoModal = ({ setLgShow, lgShow, heading, info }) => {
  const location = useLocation();
  return (
    <>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">{heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4" style={{textAlign:"justify", fontSize:"13px", lineHeight:"20px", fontFamily:"'Poppins', sans-serif"}}>
{

  location.pathname==="/BuyingSide" ? (<div>{info}</div>) : ( <> <div
  dangerouslySetInnerHTML={{ __html: info }}
/></>)
}        
        

</Modal.Body>
      </Modal>
    </>
  );
};

export default DashboardinfoModal;
